import CheckBoxOutlineBlankSharpIcon from '@mui/icons-material/CheckBoxOutlineBlankSharp';
import CheckBoxSharpIcon from '@mui/icons-material/CheckBoxSharp';
import IndeterminateCheckBoxSharpIcon from '@mui/icons-material/IndeterminateCheckBoxSharp';
import { Checkbox, FormControlLabel, styled } from '@mui/material';
import _ from 'lodash';
import React from 'react';

interface Props {
  checked: boolean;
  indeterminate?: boolean;
  value?: string | boolean;
  label?: string;
  disabled?: boolean;
  visualizeUnchecked?: boolean;
  disableUncheckedColor?: boolean;
  padding?: string;
  dense?: boolean;

  onChange?(event: React.ChangeEvent<HTMLInputElement>): void;

  onClick?(event: any): void;
}

interface StyledCheckboxProps {
  ownerState: {
    disableUncheckedColor?: boolean;
    padding?: string;
    dense?: boolean;
  };
}

const StyledFormControlLabel = styled(FormControlLabel, {
  shouldForwardProp: (prop) => prop !== 'ownerState',
})<{ ownerState: { dense?: boolean } }>(({ theme, ownerState }) => ({
  marginLeft: 0,
  marginRight: 0,
  '& .MuiFormControlLabel-label': {
    fontSize: !ownerState.dense ? theme.typography.pxToRem(15) : theme.typography.pxToRem(13),
    marginLeft: '8px',
    marginRight: 0,
  },
  '&.unchecked': {
    '& .MuiFormControlLabel-label': {
      color: theme.palette.greys.light,
      fontWeight: 'bold',
    },
  },
}));

const StyledCheckbox = styled(Checkbox, {
  shouldForwardProp: (prop) => prop !== 'ownerState',
})<StyledCheckboxProps>(({ theme, ownerState }) => ({
  padding: ownerState.padding ? ownerState.padding : 0,
  '& .MuiSvgIcon-root': {
    fontSize: !ownerState.dense ? theme.typography.pxToRem(24) : theme.typography.pxToRem(20),
    color: ownerState.disableUncheckedColor ? theme.palette.greys.dark : theme.palette.primary.main,
  },
  '&.Mui-checked': {
    '& .MuiSvgIcon-root': {
      color: theme.palette.primary.main,
    },
  },
  '&.MuiCheckbox-indeterminate': {
    '& .MuiSvgIcon-root': {
      color: theme.palette.primary.main,
    },
  },
  '&.Mui-disabled': {
    '& .MuiSvgIcon-root': {
      color: theme.palette.greys.lighter,
    },
  },
  '&:hover': {
    '& .MuiSvgIcon-root': {
      color: theme.palette.secondary.main,
    },
  },
}));

const PaiCheckbox: React.FC<Props> = ({
  checked,
  indeterminate,
  value,
  label,
  disabled,
  visualizeUnchecked,
  disableUncheckedColor,
  padding,
  dense,
  onChange,
  onClick,
}) => {
  const checkboxElement = (
    <StyledCheckbox
      ownerState={{ disableUncheckedColor, padding, dense }}
      size={'medium'}
      icon={<CheckBoxOutlineBlankSharpIcon />}
      checkedIcon={<CheckBoxSharpIcon />}
      indeterminateIcon={<IndeterminateCheckBoxSharpIcon />}
      checked={checked}
      indeterminate={indeterminate}
      value={value}
      onChange={onChange}
      onClick={onClick}
      disableRipple={true}
      disabled={disabled}
    />
  );

  if (!_.isNil(label)) {
    return (
      <StyledFormControlLabel
        ownerState={{ dense }}
        className={visualizeUnchecked && !checked ? 'unchecked' : undefined}
        control={checkboxElement}
        labelPlacement={'end'}
        label={label}
      />
    );
  }

  return checkboxElement;
};

export default PaiCheckbox;
